import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate, useParams} from "react-router-dom";
import {DepartmentService} from "../services/DepartmentService";
import {setCreateButton, setSearchHandler, setTitle} from "../actions/main";
import {ArtistService} from "../services/ArtistService";
import {useFormik} from "formik";
import FormGroup from "../components/FormGroup";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";

function Artist() {

    const dispatch = useDispatch()
    const locationParams = useParams()
    const [isNew, setIsNew] = useState(false)
    const [artist, setArtist] = useState(false)
    const [loaded, setIsLoaded] = useState(false)
    const [caption, setCaption] = useState(false)
    const navigation = useNavigate()

    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });

    const updateData = () => {
        ArtistService.GetById(locationParams.artistId, '').then((res) => {

            setArtist(res)
            dispatch(setTitle(res.name))
            artistForm.setValues(res, false)
            setIsLoaded(true)
        })
    }

    useEffect(() => {
        dispatch(setTitle(''))
        dispatch(setCreateButton(false))
        dispatch(setSearchHandler(false))
        if (locationParams.artistId === 'create') {
            setIsNew(true)
            dispatch(setTitle('Новый артист'))
            setIsLoaded(true)

        } else {
            setIsNew(false)
            updateData()

        }
    }, [currentDepartment, locationParams]);

    const artistForm = useFormik({
        initialValues: {
            name: '',
            phone: '',
            phone2: '',
            phone3: '',
            comment: ''
        },
        validate: (data) => {
            let errors = {}

            if (!data.name) {
                errors.name = 'Укажите название'
            }

            return errors
        },
        onSubmit: (data) => {
            setIsLoaded(false)
            data.client_id = currentDepartment;


            if (artist && artist.id) {
                ArtistService.Update(artist.id, data).then((res) => {
                    setIsLoaded(true)
                    navigation('/artists')
                })
            } else {
                ArtistService.Create(data).then((res) => {
                    setIsLoaded(true)
                    navigation('/artists')
                })
            }
        }
    })

    const checkExist = (fio) => {

        if(fio.length >= 3) {
            ArtistService.GetList({
                filter: {
                    s: fio
                }
            }, '').then((response, h) => {

                let c = []
                if (response && response.items && response.items.length > 0) {


                    response.items.map((item) => {
                        c.push({
                            id: item.id,
                            name: item.name
                        })
                    })
                }

                setCaption(c)

            })
        } else {
            setCaption([])
        }
    }

    return (
        <>
            <div className="card edit-department">
                <div className="card-body">
                    <form onSubmit={artistForm.handleSubmit}>

                        <FormGroup label={'Название/имя артиста'} error={artistForm.errors.name}>
                            <InputText value={artistForm.values.name} onChange={(e) => {
                                artistForm.setFieldValue('name', e.target.value)
                                checkExist(e.target.value)
                            }}/>

                            {locationParams.artistId === 'create' && caption && caption.length > 0 && <>
                                <div className={'m-t-10'}>
                                    <strong>Найдены похожие:</strong>
                                    <ul>
                                        {caption.map((row) => {
                                            return (<li key={row.id}>
                                                <Link to={'/artist/' + row.id}>{row.name}</Link>
                                            </li>)
                                        })}
                                    </ul>
                                </div>
                            </>}
                        </FormGroup>

                        <div className="row">

                            <div className="col-md-4">
                                <FormGroup label={'Телефон директора'}>
                                    <InputText value={artistForm.values.phone}
                                               onChange={(e) => artistForm.setFieldValue('phone', e.target.value)}/>
                                </FormGroup>
                            </div>
                            <div className="col-md-4">
                                <FormGroup label={'Телефон админа'}>
                                    <InputText value={artistForm.values.phone2}
                                               onChange={(e) => artistForm.setFieldValue('phone2', e.target.value)}/>
                                </FormGroup>
                            </div>
                            <div className="col-md-4">
                                <FormGroup label={'Телефон тех.'}>
                                    <InputText value={artistForm.values.phone3}
                                               onChange={(e) => artistForm.setFieldValue('phone3', e.target.value)}/>
                                </FormGroup>
                            </div>
                        </div>

                        <FormGroup label={'Комментарий'}>
                            <InputTextarea value={artistForm.values.comment}
                                           onChange={(e) => artistForm.setFieldValue('comment', e.target.value)}
                                           autoResize={true}/>
                        </FormGroup>


                        <Button label={'Сохранить'} type={'submit'} loading={!loaded}/>

                    </form>
                </div>
            </div>
        </>
    )

}

export default Artist